export { default } from './GenericModal';
